import React, { Component, Fragment } from "react";
import { matchPath } from "react-router";
import api from "services/api";

import { connect } from "react-redux";

import { Page, Form, Loading } from "components";

import { withTranslation } from "react-i18next";
import { compose } from "recompose";

const letter = ["A", "B", "C", "D", "E", "F"];

class West extends Component {
  state = {
    confirmed: false,
    journey: {},
    quiz: {},
    loading: true,
    points: 0,
    answering: false,
    initializated: false
  };

  async componentDidMount() {
    await localStorage.setItem("west_face_initializated", true);
    this.loadInterview();
  }

  loadInterview = async () => {
    const { history } = this.props;

    const response = await api.get(`search/interviews/${this.handleGetID()}`);
    const { data } = response.data;

    const type = data.attributes.interviewable_type;
    const IS_WEST = "WestFace::Quiz";

    const face =
      type === IS_WEST
        ? data.attributes.interviewable
        : data.attributes.interviewable.west_face_quiz;

    if (face.current_question === 0) {
      history.push(`/journey/${this.handleGetID()}/complete`);
      return;
    } else if (face.current_question === 1) {
      await localStorage.setItem("west_face_initializated", false);
    }

    const initializated = await JSON.parse(
      localStorage.getItem("west_face_initializated")
    );
    this.setState({ initializated });

    this.setState({ journey: face });
    this.loadQuiz(face);
  };

  loadQuiz = async face => {
    const response = await api.get(
      `west_face/quizzes/${face.id}/questions/page?page=${face.current_question}&per=1`
    );
    const { data } = response.data;

    const quiz = data[0];

    this.setState({
      quiz: {
        ...quiz,
        attributes: {
          ...quiz.attributes,
          question: {
            ...quiz.attributes.question,
            alternatives: quiz.attributes.question.alternatives.map(
              (alternative, index) => ({
                ...alternative,
                value: 0
              })
            )
          }
        }
      },
      loading: false,
      answering: false
    });
  };

  handleGetID = () => {
    const { location } = this.props;
    const match = matchPath(location.pathname, { path: "/journey/:id/west" });
    return match.params.id;
  };

  handleChangeAlternative = async (id, value) => {
    const { journey, quiz } = this.state;
    const { alternatives } = quiz.attributes.question;

    const index = alternatives.map(alternative => alternative.id).indexOf(id);
    const current = await alternatives.reduce(
      (total, alternative) => total + alternative.value,
      0
    );
    const total = await alternatives.reduce((total, alternative) => {
      return alternative.id === id ? total + value : total + alternative.value;
    }, 0);

    if (total <= journey.points) {
      quiz.attributes.question.alternatives[index].value = value;
    } else {
      quiz.attributes.question.alternatives[index].value =
        journey.points - current;
    }

    this.setState({
      quiz,
      points: quiz.attributes.question.alternatives.reduce(
        (total, alternative) => total + alternative.value,
        0
      )
    });
  };

  handleConfirm = () => {
    const { confirmed } = this.state;

    this.setState({ confirmed: !confirmed });
  };

  handleAnswer = async () => {
    const { journey, quiz } = this.state;
    const { user, t } = this.props;
    const { alternatives } = quiz.attributes.question;

    const total = await alternatives.reduce(
      (total, alternative) => total + alternative.value,
      0
    );

    if (total !== 15) {
      alert(`${t("Você precisa distribuir todos os")} ${journey.points} ${t("pontos")}`);
      return;
    }

    this.setState({ answering: true });

    await api.post(`west_face/quizzes/quizquestion/${quiz.id}/respond`, {
      interview_id: this.handleGetID(),
      person_id: user.data.id,
      alternatives: quiz.attributes.question.alternatives
    });

    this.setState({ confirmed: false });

    await this.loadInterview();
  };

  handleInitialize = async () => {
    await localStorage.setItem("west_face_initializated", true);
    this.setState({ initializated: true });
  };

  render() {
    const {
      confirmed,
      journey,
      quiz,
      loading,
      points,
      answering,
      initializated
    } = this.state;
    const { t } = this.props;

    return (
      <Page className="journey">
        {!loading && (
          <Fragment>
            {!initializated ? (
              <div className="text-center">
                <div className="header">
                  <div className="title">
                    <span className="face">{journey.instructions_content}</span>
                  </div>
                </div>

                <div className="row">
                  <div className="col-12">
                    <button
                      type="button"
                      className="button-submit"
                      onClick={this.handleInitialize}
                    >
                      {t("Iniciar Questionário")}
                    </button>
                  </div>
                </div>
              </div>
            ) : (
              <Fragment>
                <div className="header">
                  <span className="step">{`${journey.current_question}/${journey.total_questions}`}</span>
                  <div className="title">
                    <span className="face">{t("Face Oeste")}</span>
                    <span className="question">
                      {quiz.attributes.question.title}
                    </span>
                  </div>
                </div>

                <div className="questions">
                  <div className="options options-slide">
                    <span>{t("Menos")}</span>
                    <span>{t("Me Identifico")}</span>
                    <span>{t("Mais")}</span>
                  </div>

                  {quiz.attributes.question.alternatives.map(
                    (alternative, index) => (
                      <div className="question" key={alternative.id}>
                        <div className="question-title">
                          <span className="question-label">
                            {letter[index]}
                          </span>
                          <span className="question-name">
                            {alternative.title}
                          </span>
                        </div>

                        <div className="question-options">
                          <Form.Slider
                            minValue={0}
                            maxValue={journey.points}
                            value={alternative.value}
                            onChange={value =>
                              this.handleChangeAlternative(
                                alternative.id,
                                value
                              )
                            }
                          />
                          <div className="option-value">
                            {alternative.value}
                          </div>
                        </div>
                      </div>
                    )
                  )}

                  <span className="points">{`${points}/${journey.points} ${t(
                    "pontos distribuídos"
                  )}.`}</span>
                </div>

                <div className="buttons">
                  <button
                    type="button"
                    disabled={!confirmed || answering}
                    className="button-submit"
                    onClick={this.handleAnswer}
                  >
                    {answering ? (
                      <Loading size="xs" text={t("Respondendo...")} />
                    ) : (
                      t("Próxima Questão")
                    )}
                  </button>

                  <Form.Checkbox
                    label={t("Confirmar Resposta")}
                    checked={confirmed}
                    onChange={this.handleConfirm}
                  />
                </div>
              </Fragment>
            )}
          </Fragment>
        )}
      </Page>
    );
  }
}

const mapState = state => ({
  user: state.auth.user
});

export default compose(connect(mapState), withTranslation())(West);



// WEBPACK FOOTER //
// ./src/pages/Journey/West/index.js